import FindItSideItem from './FindItSideItem'
import React from 'react'
import { useTrans } from 'hooks'

const FindItSide = ({ items }) => {
  const t = useTrans()

  let rivista = null
  if (items.rivista) {
    rivista = <FindItSideItem key={items.rivista.id} item={items.rivista} />
  }

  let raccolte = []
  if (items.raccolte) {
    let i = null
    for (i = 0; i < items.raccolte.length; i++) {
      raccolte.push(<FindItSideItem key={items.raccolte[i].id} item={items.raccolte[i]} />)
    }
  }

  let body = null
  if (rivista || raccolte.length) {
    body = (
      <div className="riviste-side">
        <h3 className="riviste-side__title">{t('Dove trovi questo contenuto')}</h3>
        <div className="riviste-side__items">
          {rivista}
          {raccolte}
        </div>
      </div>
    )
  }

  return body
}

export default FindItSide
